'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_GotenbergSecret(secret) {
  this.Y5 = null;
  this.Y5 = secret;
}
export { $c_Lapp_data_GotenbergSecret as $c_Lapp_data_GotenbergSecret };
$p = $c_Lapp_data_GotenbergSecret.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_GotenbergSecret;
/** @constructor */
function $h_Lapp_data_GotenbergSecret() {
}
export { $h_Lapp_data_GotenbergSecret as $h_Lapp_data_GotenbergSecret };
$h_Lapp_data_GotenbergSecret.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_GotenbergSecret) && (this.Y5 === x$0.Y5)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "GotenbergSecret";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Y5;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "secret";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_GotenbergSecret(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jy)));
}
export { $isArrayOf_Lapp_data_GotenbergSecret as $isArrayOf_Lapp_data_GotenbergSecret };
var $d_Lapp_data_GotenbergSecret = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_GotenbergSecret, "app.data.GotenbergSecret", ({
  jy: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_GotenbergSecret as $d_Lapp_data_GotenbergSecret };
//# sourceMappingURL=app.data.-Gotenberg-Secret.js.map
